import { Component, Inject } from "@angular/core";
import { FormArray, FormBuilder, FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { catchError, of } from "rxjs";
import { CommonSnackBarService } from "../../_services/common-snack-bar.service";
import { MeUserService } from "../../_services/http-api/me-user.service";
import { SharedFileService } from "../../_services/http-api/shared-file.service";
import { SpinnerService } from "../../_services/spinner.service";
import { formatDate, getExpirationDate, removeDays } from "../../_utils/date.utils";

@Component({
  selector: "app-common-images-share-dialog",
  templateUrl: "./common-images-share-dialog.component.html",
  styleUrls: ["./common-images-share-dialog.component.scss"],
  standalone: false
})
export class CommonImagesShareDialogComponent {
  public form = this.fb.group({
    emails: this.fb.array([]) as FormArray<FormControl<string>>,
    expirationDate: this.fb.control(this.formatDate(getExpirationDate()), [Validators.required])
  });
  constructor(
    private meUserService: MeUserService,
    private oscSpinnerService: SpinnerService,
    private sharedFileService: SharedFileService,
    private snackbar: CommonSnackBarService,
    private translate: TranslateService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CommonImagesShareDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { inspectionId: string }
  ) {
    this.getUserAddress();
  }

  get getEmailsControl() {
    return this.form.controls.emails;
  }

  get emails() {
    return this.form.get("emails") as FormArray<FormControl<string>>;
  }

  addEmail() {
    this.emails.push(new FormControl<string>(""));
  }

  private formatDate(date: Date) {
    return formatDate(date, "yyyy-MM-dd");
  }

  removeEmail(index: number) {
    this.emails.removeAt(index);
  }

  getUserAddress() {
    this.meUserService.getMe().subscribe((user) => this.form.controls.emails.push(this.fb.control(user.email)));
  }

  onError() {
    this.snackbar.open(this.translate.instant("shareInspection.error"));
    return of({});
  }

  shareInspectionFolder() {
    this.oscSpinnerService.show();
    // This is needed because of timezone not well handle in the BE for the start date of the download link. To avoid any problem we enabled the link 1 day ahead of the current day.
    const startDate = removeDays(new Date(), 1).toISOString();
    this.sharedFileService
      .sharedFileSasKey(this.data.inspectionId, "Inspection", startDate, this.form.value.expirationDate, this.form.value.emails)
      .pipe(catchError(() => this.onError()))
      .subscribe((r) => {
        this.oscSpinnerService.hide();
        this.snackbar.open(this.translate.instant("shareInspection.success"));
        this.dialogRef.close();
      });
  }
}
